<template>
	<div class="list-orders">
		<loading :active.sync="this.$store.getters.isOrderLoading" 
        :can-cancel="true" 
        :is-full-page="fullPage"></loading>
	
		<FilterBar></FilterBar>
		<div class="list-orders__pagination-wrap">
			<pagination :totalpage="this.$store.getters.getTotalPage" :pageno="this.pageno" ></pagination> 
		</div>
		<div class="list-orders__content-wrap">
			<h2 class="table-title list-orders__title">
				ORDER LIST - Total Orders:<span> {{ this.$store.getters.getTotalCount }}</span>
			</h2>
			<!--  -->
			<LabelsTable></LabelsTable>
			<!--  -->
			<div class="list-orders__page">
				<OrderTable
					v-for="(item, index) in tableData"
					:key="item.serial"
					:orderData="item"
					:index="index"
				></OrderTable>
			</div>
			<!--  -->
			<!--
			<div class="list-orders__pagination-wrap">
				<pagination totalpage=2 currpage={{  this.pageno }}></pagination>
			</div>
			-->
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import FilterBar from "../components/listOrders/FilterBar.vue";
import LabelsTable from "../components/listOrders/LabelsTable.vue";
import OrderTable from "../components/listOrders/OrderTable.vue";
import pagination from "../components/global/Pagination.vue";

import { mapActions } from "vuex";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
	
export default Vue.extend({
	name: "ListOrders",
	components: {
		FilterBar,
		LabelsTable,
		OrderTable,
		pagination,
		Loading
	},
	methods: {
		...mapActions(["getData"])
	},
	data() {
		return {
			totalPage: 0,
			pageno: 1,
		};
	},
	computed: {
		tableData: {
			get() {
				
				return this.$store.getters.getListData;
			}
		}
	},
	mounted() {
	
		this.getData();
		
		if (this.$route.params.pageno) {
			this.pageno = this.$route.params.pageno;
			this.$store.commit('updatePageNo', this.$route.params.pageno);
		} else {
			this.pageno = 1;
		}
	
		//this.getData();
		
	}
});
</script>

<style lang="scss" scoped>
.list-orders {
	&__title {
		text-align: center;
		position: relative;
		margin-top: 0px;

		&::before {
			content: "Select/Deselect All";
			display: inline-block;
			position: absolute;

			font-weight: 600;
			font-size: 9px;

			transform: translateY(-50%);
			left: 10px;
			top: 50%;
		}
	}

	&__pagination-wrap {
		padding: 30px 0;
	}

	&__content-wrap {
		padding: 0 20px;
	}
}
</style>